var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNounPlayButton377971(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.001,9.082C27.403,9.082,9.082,27.4,9.082,50c0,22.598,18.321,40.918,40.919,40.918  c22.598,0,40.918-18.32,40.918-40.918C90.919,27.4,72.599,9.082,50.001,9.082z M71.026,52.839c-0.306,0.253-0.654,0.453-1.029,0.596  L41.88,69.667c-0.393,0.362-0.864,0.642-1.392,0.806c-0.345,0.108-0.71,0.163-1.089,0.163c-2.036,0-3.687-1.647-3.687-3.684V33.05  c0-2.038,1.651-3.688,3.687-3.688c0.479,0,0.941,0.097,1.362,0.265c0.329,0.132,0.636,0.309,0.911,0.525l28.672,16.553l0.405,0.23  c0.978,0.664,1.623,1.788,1.623,3.06C72.372,51.142,71.847,52.167,71.026,52.839z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNounPlayButton377971);
export default __webpack_public_path__ + "static/media/noun_play_button_377971.4626733a.svg";
export { ForwardRef as ReactComponent };